import React, { useState } from "react";
import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  ExpandableRowContent
} from "@patternfly/react-table";

import { SheetIdCell } from "./table/columns/SheetIdCell";
import { SheetNameCell } from "./table/columns/SheetNameCell";
import { SheetTypesCell } from "./table/columns/SheetTypesCell";
import { SheetAnswerKeyCell } from "./table/columns/SheetAnswerKeyCell";
import { SheetYearCell } from "./table/columns/SheetYearCell";
import { GroupsCell } from "./table/columns/GroupsCell";
import { DevAttachmentCell } from "./table/columns/DevAttachmentCell";
import { DevSolutionsCell } from "./table/columns/DevSolutionsCell";

import { SheetDetails } from "./table/datails/SheetDetails";

import { useBranch } from "../hooks/useBranch";
import { NoResults } from "shared/utils/NoResults";

export const SheetTable = ({
  props,
  context,
  header,
  SheetsData,
  Icons,
  sheets,
  setSheets,
  groupFilter
}) => {
  const branch = useBranch();
  const [expandedSheetId, setExpandedSheetId] = useState(null);

  const visibleHeaders = header
    // .filter(h => context.state.isAuthUser || h.name !== "Grupy")
    // .filter(h => context.state.isAuthUser || h.name !== "Rozwiązania");
    .filter(h => context.state.isAuthUser || h.name !== "Grupy")
    .filter(h => context.state.isAuthUser || h.name !== "Rozwiązania");

  const columnCount = visibleHeaders.length + 1; // +1 for expand column

  return (
    <>
      {(sheets || []).length === 0 ? (
        <NoResults
          title="Nie znaleziono wyników"
          message="Żaden arkusz nie spełnia kryteriów wyszukiwania lub filtrów."
        />
      ) : (
        <Table variant="compact" isExpandable>
          <Thead>
            <Tr>
              <Th screenReaderText="Expand row" />
              {visibleHeaders.map(h => (
                <Th key={h.name}>{h.name}</Th>
              ))}
            </Tr>
          </Thead>

          {(sheets || []).map((row, rowIndex) => {
            const isExpanded = expandedSheetId === row.id;
            return (
              <Tbody key={row.id} isExpanded={isExpanded}>
                {/* GŁÓWNY WIERSZ */}
                <Tr
                  isSelectable
                  isRowSelected={isExpanded}
                  isContentExpanded={isExpanded}
                  onRowClick={() =>
                    setExpandedSheetId(isExpanded ? null : row.id)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <Td
                    expand={{
                      rowIndex,
                      isExpanded,
                      onToggle: () =>
                        setExpandedSheetId(isExpanded ? null : row.id)
                    }}
                  />

                  <Td>
                    <SheetIdCell id={row.id} isSelected={isExpanded} />
                  </Td>

                  <Td>
                    <SheetNameCell
                      row={row}
                      props={props}
                      context={context}
                      withMiniature={true}
                      isExpandedRow={isExpanded}
                    />
                  </Td>

                  <Td>
                    <SheetTypesCell
                      row={row}
                      Icons={Icons}
                      groupFilter={groupFilter}
                    />
                  </Td>

                  <Td>
                    <SheetAnswerKeyCell
                      row={row}
                      props={props}
                      context={context}
                    />
                  </Td>

                  <Td>
                    <SheetYearCell row={row} />
                  </Td>

                  {context.state.isAuthUser && (
                    <Td>
                      <GroupsCell row={row} groupFilter={groupFilter} />
                    </Td>
                  )}

                  {SheetsData.headers.type === "dev" && (
                    <>
                      <Td>
                        <DevAttachmentCell
                          row={row}
                          props={props}
                          context={context}
                        />
                      </Td>
                      {context.state.isAuthUser && (
                        <Td>
                          <DevSolutionsCell
                            row={row}
                            props={props}
                            context={context}
                          />
                        </Td>
                      )}
                     
                      {/*
                      {context.state.isAuthUser && context.state.userProfile.is_superuser && (
                        <Td>
                            <ShareCell
                              row={row}
                              props={props}
                              setSheets={setSheets}
                              branch={branch}
                            />
                        </Td>
                      )} */}
                    </>
                  )}
                </Tr>

                {/* WIERSZ SZCZEGÓŁÓW */}
                <Tr isExpanded={isExpanded}>
                  <Td colSpan={columnCount}>
                    <ExpandableRowContent>
                      <SheetDetails
                        context={context}
                        props={props}
                        row={row}
                        Icons={Icons}
                        groupFilter={groupFilter}
                        setSheets={setSheets}
                      />
                    </ExpandableRowContent>
                  </Td>
                </Tr>
              </Tbody>
            );
          })}
        </Table>
      )}
    </>
  );
};